<template>
  <div class="result-wrapper">
    <div class="container">
      <div class="header">
        <div class="title">您的昆曲艺术形象</div>
      </div>
      <div class="content" v-if="userResult">
        <div class="result">
          <div class="result-img">
            <div class="img">
              <el-image :src="userResult.image" class="profile" />
              <div class="result-tag">{{ userResult.profession }}</div>
            </div>
          </div>
          <div class="result-title">{{ userResult.character }}</div>
          <div class="quote">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 330 307"
              height="70"
              width="70"
            >
              <path
                fill="currentColor"
                d="M302.258 176.221C320.678 176.221 329.889 185.432 329.889 203.853V278.764C329.889 297.185 320.678 306.395 302.258 306.395H231.031C212.61 306.395 203.399 297.185 203.399 278.764V203.853C203.399 160.871 207.902 123.415 216.908 91.4858C226.323 59.1472 244.539 30.902 271.556 6.75027C280.562 -1.02739 288.135 -2.05076 294.275 3.68014L321.906 29.4692C328.047 35.2001 326.614 42.1591 317.608 50.3461C303.69 62.6266 292.228 80.4334 283.223 103.766C274.626 126.69 270.328 150.842 270.328 176.221H302.258ZM99.629 176.221C118.05 176.221 127.26 185.432 127.26 203.853V278.764C127.26 297.185 118.05 306.395 99.629 306.395H28.402C9.98126 306.395 0.770874 297.185 0.770874 278.764V203.853C0.770874 160.871 5.27373 123.415 14.2794 91.4858C23.6945 59.1472 41.9106 30.902 68.9277 6.75027C77.9335 -1.02739 85.5064 -2.05076 91.6467 3.68014L119.278 29.4692C125.418 35.2001 123.985 42.1591 114.98 50.3461C101.062 62.6266 89.6 80.4334 80.5942 103.766C71.9979 126.69 67.6997 150.842 67.6997 176.221H99.629Z"
              ></path>
            </svg>
            <div class="result-quote">{{ userResult.poem }}</div>
          </div>
          <div class="result-desc">
            {{ userResult.characteristic }}
          </div>
        </div>
        <div class="intro">
          <div class="intro-header">原剧剧情介绍</div>
          <div class="intro-content">
            {{ userResult.synopsis }}
          </div>
          <!-- <div class="intro-footer">
            <wx-open-launch-weapp
              id="launch-btn"
              appid="wxff0481d92bd71c03"
              path="pages/home/home"
            >
              <component :is="'script'" type="text/wxtag-template">
                <div class="go-wx">
                  <span style="font-size: 12px; color: #725549">了解详情</span>
                  <img
                    src="https://cdn.ringdata.com/custom/perfume/19301714027732_.pic.jpg"
                    style="
                      display: inline-block;
                      vertical-align: middle;
                      width: 14px;
                      margin-left: 10px;
                    "
                  />
                </div>
              </component>
            </wx-open-launch-weapp>
          </div> -->
        </div>
        <div class="video">
          <div class="video-header">
            请欣赏由
            <span class="performer">{{ userResult.videoPerformer }}</span>
            表演的
            <span class="title">{{ `\n` + userResult.videoTitle }}</span>
          </div>
          <div class="video-content">
            <iframe
              :src="userResult.videoUrl"
              scrolling="no"
              border="0"
              frameborder="no"
              framespacing="0"
              allowfullscreen="true"
              width="80%"
              height="100%"
              style="border-radius: 10px"
            ></iframe>
          </div>
        </div>
      </div>
      <div class="footer">
        <TestStartButton
          label="再测一次"
          @click="goTestAgain"
          class="start-button"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
// import initWx from "@/utils/weixin.config";
import { FEMALE_TEST_RESULT, MALE_TEST_RESULT } from "@/constant/result.js";
import TestStartButton from "@/components/TestStartButton.vue";

const route = useRoute();
const router = useRouter();

const gender = ref(route.params.gender);

//测试结果
const testResults = ref(FEMALE_TEST_RESULT);
//结果
const userResult = ref(null);

const initResults = () => {
  switch (gender.value) {
    case "FEMALE":
      testResults.value = FEMALE_TEST_RESULT;
      break;
    case "MALE":
      testResults.value = MALE_TEST_RESULT;
      break;
    default:
      break;
  }
};

const getResult = () => {
  // 初始化每个选项的计数器
  let counters = {
    attribute1: 0,
    attribute2: 0,
    attribute3: 0,
  };
  const testAnswers = JSON.parse(
    window.sessionStorage.getItem("kunqu_test_answer")
  );
  // 统计每个属性的数量
  testAnswers.forEach((item) => {
    if (counters[item] !== undefined) {
      counters[item]++;
    }
  });
  const { attribute1, attribute2, attribute3 } = counters;
  // 比较数量
  if (attribute1 > attribute2 && attribute1 > attribute3) {
    userResult.value = testResults.value.resultA; // attribute1最多
  } else if (attribute2 > attribute1 && attribute2 > attribute3) {
    userResult.value = testResults.value.resultC; // attribute2最多
  } else if (attribute3 > attribute1 && attribute3 > attribute2) {
    userResult.value = testResults.value.resultE; // attribute3最多
  } else if (attribute1 === attribute2 && attribute1 > attribute3) {
    userResult.value = testResults.value.resultB; // attribute1和attribute2一样多且最多
  } else if (attribute1 === attribute3 && attribute1 > attribute2) {
    userResult.value = testResults.value.resultD; // attribute1和attribute3一样多且最多
  } else if (attribute2 === attribute3 && attribute2 > attribute1) {
    userResult.value = testResults.value.resultF; // attribute2和attribute3一样多且最多
  } else {
    userResult.value = null; // 三个属性都一样多(不可能)
  }
};

//重新测试
const goTestAgain = () => {
  router.replace({ name: "Index" });
};

let bgmAudio = null;
const playBgm = () => {
  bgmAudio = new Audio(userResult.value.bgm);
  bgmAudio.loop = true; // 设置循环播放
  bgmAudio.play().catch((error) => {
    console.log("自动播放受阻：", error);
  });
};

onMounted(() => {
  // initWx();
  initResults();
  getResult();
  playBgm();
});

onBeforeUnmount(() => {
  if (bgmAudio) {
    bgmAudio.pause();
    bgmAudio.currentTime = 0; // 重置播放时间
  }
});
</script>

<style lang="scss" scoped>
$header-height: 100px;
$footer-height: 150px;
.result-wrapper {
  height: 100vh;
  background-color: #ffffff;
  overflow-y: auto;
  .container {
    width: 100%;
    height: 100%;
    .header {
      width: 100%;
      height: $header-height;
      display: flex;
      align-items: center;
      justify-content: center;
      .title {
        color: #8c9285;
        font-size: 18px;
      }
    }
    .content {
      width: 100%;
      min-height: calc(100% - $header-height - $footer-height);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      gap: 20px;
      margin-top: 100px;
      .result {
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
        width: 35%;
        border-radius: 10px;
        background-color: #f5f2eb;
        position: relative;
        padding: 110px 10px 10px 10px;
        .result-img {
          width: 200px;
          height: 200px;
          position: absolute;
          top: -100px;
          .img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            position: relative;
            .profile {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
            .result-tag {
              width: 25px;
              position: absolute;
              right: -35px;
              top: 5px;
              font-size: 14px;
              color: #8c9285;
              background-color: #e9eddf96;
              padding: 5px;
              border-radius: 5px;
            }
          }
        }
        .result-title {
          color: $font-color;
          font-size: 20px;
          font-weight: 550;
          text-align: left;
          margin-top: 10px;
        }
        .quote {
          color: #ebe4d2;
          position: relative;
          width: 100%;
          padding: 15px 30px 5px 30px;
          text-align: left;
          .result-quote {
            font-size: 14px;
            color: $font-color;
            position: absolute;
            top: 35px;
            left: 60px;
            line-height: 23px;
          }
        }
        .result-desc {
          font-size: 15px;
          line-height: 24px;
          white-space: pre-line;
          text-align: justify;
          padding: 10px 20px;
          color: $font-color;
          border-radius: 10px;
        }
      }
      .intro {
        box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
        width: 35%;
        border-radius: 10px;
        background-color: #e9eddf96;
        padding: 30px;
        .intro-header {
          color: #8c9285;
          font-weight: 550;
          font-size: 18px;
          margin-bottom: 15px;
        }
        .intro-content {
          color: #8c9285;
          line-height: 24px;
          font-size: 15px;
          white-space: pre-line;
          text-align: justify;
          position: relative;
        }
        .intro-footer {
        }
      }
      .video {
        box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
        width: 35%;
        border-radius: 10px;
        background-color: #d9e4e680;
        padding: 30px;
        .video-header {
          color: #899496;
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 20px;
          white-space: pre-line;
          padding: 0 30px;
          .performer {
          }
          .title {
            font-weight: 550;
            font-size: 16px;
          }
        }
        .video-content {
          height: 200px;
        }
      }
    }
    .footer {
      width: 100%;
      height: $footer-height;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.header,
.result,
.intro,
.video,
.start-button {
  opacity: 0;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.header {
  animation: fadeIn 1s ease forwards 0.5s;
}
.result {
  animation: fadeIn 1s ease forwards 1s;
}
.intro {
  animation: fadeIn 1s ease forwards 1.5s;
}
.video {
  animation: fadeIn 1s ease forwards 2s;
}
.start-button {
  animation: fadeIn 1s ease forwards 2.5s;
}
@media screen and (max-width: 768px) {
  .result {
    width: 80% !important;
  }
  .intro {
    width: 80% !important;
  }
  .video {
    width: 80% !important;
    .video-header {
      padding: 0px !important;
    }
    .video-content {
      height: 120px !important;
    }
  }
}
</style>
